import http from "./httpService";

class AssetsApi {
  headers = {
    accept: "application/json, text/plain, */*",
    "content-type": "application/json",
  };

  async getAssetsOptions(
    sortType,
    searchTxt,
    pickupDate,
    returnDate,
    pickupTime,
    returnTime,
    availFlag,
    selCategoryTypeIds,
    selLocation
  ) {
    let sortValue = sortType.sortType || '';
    let sortOrder = sortType.sortOrder || '';
    const ids = Array.isArray(selCategoryTypeIds)
      ? selCategoryTypeIds.filter((id) => id != null && id !== '')
      : [];
    let categoryParam = '';
    ids.forEach((assetCategoryId) => {
      categoryParam += `&assetCategoryId=${assetCategoryId}`;
      });
    const location =
      selLocation == null || selLocation === ''
        ? { value: '' }
        : typeof selLocation === 'object'
          ? selLocation
          : { value: selLocation };

    let locIds = [];
  	if (location.value === '' || location.value == null) {
  	} else {
      locIds = [location.value];
      if(location?.obj?.childIds){
      	locIds = [...[location.value],...location?.obj?.childIds];
	  }
  	}
    let locationAry = '';
    locIds.forEach((locationId) => {
      locationAry += `&locationId=${locationId}`;
    });

    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api-asset/asset/search/portal?pickupStr=${pickupDate}&returnStr=${returnDate}&pickupTime=${pickupTime}&returnTime=${returnTime}&sort=${sortValue}&sortOrder=${sortOrder}&searchFilter=${searchTxt}&filterAvailable=${availFlag}${categoryParam}${locationAry}`
    );
  }

  async checkAssetAvailable(
    assetID,
    pickupDate,
    returnDate,
    pickupTime,
    returnTime
  ) {
    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api-asset/asset/search/portal?pickupStr=${pickupDate}&returnStr=${returnDate}&pickupTime=${pickupTime}&returnTime=${returnTime}&assetId=${assetID}`
    );
  }

  async validateAssetRental(
      assetID,
      pickupDate,
      returnDate,
      pickupTime,
      returnTime
    ) {
      return http.get(
        process.env.REACT_APP_BASE_URL +
          `api-asset/asset/rental/validate?pickupStr=${pickupDate}&returnStr=${returnDate}&pickupTime=${pickupTime}&returnTime=${returnTime}&assetId=${assetID}`
      );
    }
  async getAssetRate(assetId) {
    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api-asset/asset/${assetId}/rate`
    );
  }
  async getAssetAddonServices(assetId) {
    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api-asset/asset/${assetId}/service/addon/list?type=Public`
    );
  }
  async getAssetQuestions(assetId, type) {
    const typeParam = type ? `?type=${encodeURIComponent(type)}` : '';
    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api-asset/asset/${assetId}/question/list${typeParam}`
    );
  }
  async getBookingFee(assetID, pickupDate, pickupTime, returnDate, returnTime, promoCode = '', serviceIds = []) {
    const ids = Array.isArray(serviceIds) ? serviceIds.filter((x) => x !== null && x !== undefined && `${x}` !== '') : [];
    const serviceIdsParam = ids.length ? `&serviceIds=${encodeURIComponent(ids.join(','))}` : '';
    const bookingFeeData = `?assetId=${assetID}&pickupDate=${pickupDate}&pickupTime=${pickupTime}&returnDate=${returnDate}&returnTime=${returnTime}&promoCode=${promoCode}${serviceIdsParam}`; //&surcharge=$Asset_Surcharge
    return http.get(process.env.REACT_APP_BASE_URL + `api/booking/bill/fee${bookingFeeData}`);
  }
  async getAssetDetail(assetId) {
    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api-asset/asset/${assetId}/detail`
    );
  }
  async getCategories() {
    return http.get(
      process.env.REACT_APP_BASE_URL +
        'api-asset/asset/category/list?includeHidden=false&selected=true'
    );
  }

  async getSimilarAsset(
    assetId,
    pickupDate,
    returnDate,
    radius,
    pageCount,
  ) {
    const url = `${process.env.REACT_APP_BASE_URL
    }/api-asset/asset/list/similar?assetId=${assetId}&pickupStr=${pickupDate}&returnStr=${returnDate}&radius=${radius}&pageCount=${pageCount}`;

    return http.get(url);
  }

  async getAssetAgreement(assetId) {
    return http.get(
      process.env.REACT_APP_BASE_URL +
        `api-asset/asset/${assetId}/agreement`
    );
  }
}



export const assetsApi = new AssetsApi();
